import React from 'react';
import ExaminerContainer from '../ExaminerContainer';
import ExaminerEmailsList from './ExaminerEmailsList';
import { Redirect } from 'react-router-dom';
import { isLoggedIn } from '../../../api';

interface Props {
}

export default class ExaminerEmailsPage extends React.Component<Props> {

  render() {
    if (!isLoggedIn('examiner')) {
      return <Redirect to='/login' />
    }

    return (
      <ExaminerContainer heading="Email Templates">
        <ExaminerEmailsList />
      </ExaminerContainer>
    )
  }
}

